export const getKids = kids => {
  switch (Number(kids)) {
    case 0:
      return 'Not Allowed';
    case 1:
      return 'Ages 0-6 Free';
    case 2:
      return 'Allowed, full price';
    default:
      return 'Ages 0-6 Free';
  }
};
